import { Injectable } from '@angular/core';
import { ColorRecipeModel } from '../edit/models/color-recipe.model';
import { Store } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { ViewTreeNode } from './models/view.tree-node';
import { EngineService } from './engine.service';
import { PaintPresets, PaintPresetOriginal, PaintPresetFade } from './models/paint-presets.const';
import { BdGraph } from 'src/lib/graph/graph.model';

declare const Human: any;

@Injectable({
  providedIn: 'root'
})
export class PaintService {

  constructor(
    private store: Store,
    private graphService: BdGraphService,
    private engineService: EngineService
  ) { }

  paint(node: ViewTreeNode, recipe: ColorRecipeModel) {
    // relay color mods to each engine leaf
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    this.graphService.getLeafDescendants(viewGraph, node.id).forEach((id) => {
      this.engineService.getObjects(id).forEach((humanObjectId: string) => {
        const humanObject = Human.scene.objects[humanObjectId];
        if (humanObject instanceof Human.scene.Object) {
          const engineRecipe = ColorRecipeModel.toEngine(recipe);

          // reset object mod properties
          humanObject.clearColorModProperties();
          humanObject.clearOpacityModProperties();

          // apply mod properties that are not default
          if (engineRecipe.hasOwnProperty('tintColor')) {
            humanObject.setTintColor(engineRecipe.tintColor);
          }
          if (engineRecipe.hasOwnProperty('saturation')) {
            humanObject.setSaturation(engineRecipe.saturation);
          }
          if (engineRecipe.hasOwnProperty('brightness')) {
            humanObject.setBrightness(engineRecipe.brightness);
          }
          if (engineRecipe.hasOwnProperty('contrast')) {
            humanObject.setContrast(engineRecipe.contrast);
          }
          if (engineRecipe.hasOwnProperty('opacity')) {
            humanObject.setOpacity(engineRecipe.opacity);
          }
        }
      });
    });
  }

  highlight(node: ViewTreeNode, highlight: boolean) {
    // relay highlight to each engine leaf
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    this.graphService.getLeafDescendants(viewGraph, node.id).forEach((id) => {
      this.engineService.getObjects(id).forEach((humanObjectId: string) => {
        const humanObject = Human.scene.objects[humanObjectId];
        if (humanObject instanceof Human.scene.Object) {
          humanObject.setHighlight(highlight);
        }
      });
    });
  }

  xRay(node: ViewTreeNode, xRay: boolean) {
    const object = Human.scene.objects[node.id];
    object.setXRay(xRay);
  }

  paintAll(nodes: ViewTreeNode[], recipe: ColorRecipeModel) {
    nodes.forEach(node => {
      this.paint(node, recipe);
    });
  }

  highlightAll(nodes: ViewTreeNode[], highlight: boolean) {
    nodes.forEach(node => {
      this.highlight(node, highlight);
    });
  }

  inverseXRay(nodes: ViewTreeNode[], viewGraph: BdGraph<ViewTreeNode>) {
    const nodeIds = nodes.map(node => node.id);

    const inverseNodeIds = this.graphService.getInverseSelection(viewGraph, nodeIds);
    const inverseNodes = this.graphService.getNodes(viewGraph, inverseNodeIds);

    this.paintAll(inverseNodes, PaintPresetFade.recipe);
    this.paintAll(nodes, PaintPresetOriginal.recipe);
  }
}
